<template>
  <div class="circle-svg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="162"
      height="162"
      viewBox="0 0 162 162"
      fill="none"
    >
      <path
        d="M-3.54062e-06 81L0.443722 89.4668L1.77004 97.8409L3.96442 106.03L7.00281 113.946L10.8519 121.5L15.4696 128.611L20.8053 135.2L26.8004 141.195L33.3894 146.53L40.5 151.148L48.0543 154.997L55.9696 158.036L64.1591 160.23L72.5332 161.556L81 162L89.4668 161.556L97.8408 160.23L106.03 158.036L113.946 154.997L121.5 151.148L128.611 146.53L135.2 141.195L141.195 135.2L146.53 128.611L151.148 121.5L154.997 113.946L158.036 106.03L160.23 97.8409L161.556 89.4668L162 81L161.556 72.5332L160.23 64.1592L158.036 55.9696L154.997 48.0543L151.148 40.5L146.53 33.3894L141.195 26.8004L135.2 20.8053L128.611 15.4696L121.5 10.8519L113.946 7.00282L106.03 3.96443L97.8409 1.77005L89.4668 0.443729L81 3.54062e-06L72.5332 0.443729L64.1591 1.77005L55.9696 3.96443L48.0543 7.00282L40.5 10.8519L33.3894 15.4696L26.8004 20.8053L20.8053 26.8004L15.4696 33.3894L10.8519 40.5L7.00281 48.0543L3.96442 55.9696L1.77004 64.1591L0.443722 72.5332L-3.54062e-06 81Z"
        fill="#7EEAB1"
        fill-opacity="0.25"
      />
    </svg>
  </div>
</template>

<style scoped>
.circle-svg {
  display: inline-block;
}
</style>
